import React from "react";
import { Grid, Paper } from "@material-ui/core";
import {} from "@material-ui/core/styles";
import PersonelCard from "./bioComponent/PersonelCard";
import Header from "./mainComponents/Header";
import { makeStyles } from "@material-ui/core/styles";
import Brandon from "../static/images/Brandon";
import Jared from "../static/images/Muhammad";
import Muhammad from "../static/images/Jared";
import { bio } from "../data";

const useStyles = makeStyles({
  container: {
    padding: "3rem",
  },
  gridItem: {
    display: "flex",
    justifyContent: "center",
  },
  accordSty: {
    padding: "2rem",
  },
});

const Bio = () => {
  const classes = useStyles();
  const imgs = [<Jared />, <Brandon />, <Muhammad />];
  const renderCards = [
    bio.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Grid item lg={4} xs={12} className={classes.gridItem}>
            <PersonelCard data={item}>{imgs[index]}</PersonelCard>
          </Grid>
        </React.Fragment>
      );
    }),
  ];
  return (
    <>
      <Paper style={{ padding: "2rem" }}>
        <Header headerText={"About our Team"} />
        <Grid container className={classes.container}>
          {renderCards}
        </Grid>
      </Paper>
    </>
  );
};

export default Bio;
